export default "__VITE_ASSET__BMttG3mu__"